module.exports = __webpack_public_path__ + "img/news-img1.4ff5cd73.svg";